import { render, staticRenderFns } from "./GlossaryCategoriesEdit.vue?vue&type=template&id=4f580b14&scoped=true&"
import script from "./GlossaryCategoriesEdit.vue?vue&type=script&lang=js&"
export * from "./GlossaryCategoriesEdit.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryCategoriesEdit.vue?vue&type=style&index=0&id=4f580b14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f580b14",
  null
  
)

export default component.exports